export const MIME_TYPE_JSON = 'application/json';
export const MIME_TYPE_STREAM = 'application/octet-stream';
export const MIME_TYPE_TEXT = 'text/plain';
export const MIME_TYPE_XLS = 'application/vnd.ms-excel';
export const MIME_TYPE_XLSX =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
